import React from "react";
import "../styles/Contact.css";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const Contact = () => {
  return (
    <section className="contact-section">
      <h2 className="contact-title">Contacto</h2>
      <p className="contact-subtitle">
        ¿Tienes alguna pregunta o necesitas más información? <br />
        <strong>¡Estoy aquí para ayudarte!</strong>
      </p>

      <div className="contact-cards">
        <div className="contact-card">
          <FaPhoneAlt className="contact-icon" />
          <h3>Teléfono</h3>
          <p>
            Llámame al <strong>+34 637 09 85 42</strong> <br />
            Estaré encantada de atenderte.
          </p>
        </div>

        <div className="contact-card">
          <FaEnvelope className="contact-icon" />
          <h3>Email</h3>
          <p>
            Escríbeme a <strong>doinaro@doina.com</strong> <br />
            y te responderé lo antes posible.
          </p>
        </div>

        <div className="contact-card">
          <FaWhatsapp className="contact-icon" />
          <h3>WhatsApp</h3>
          <p>
            Mándame un mensaje al <strong>+34 637 09 85 42</strong> <br />
            y te responderé rápidamente.
          </p>
        </div>
      </div>

      <p className="contact-footer">
        Estoy disponible para resolver cualquier duda o consulta que tengas.
        <br /> <strong>¡Espero tu mensaje!</strong>
      </p>
    </section>
  );
};

export default Contact;